export const salesChannelChartMock = [
  {
    name: 'Spotify',
    total: 85432.89,
    a: 76955.77, // 90% of total
    b: 8477.12, // total - a
  },
  {
    name: 'Amazon',
    total: 53782.45,
    a: 39264.56, // 73% of total
    b: 14517.89, // total - a
  },
  {
    name: 'Apple',
    total: 67913.12,
    a: 65356.78, // 96% of total
    b: 2556.34, // total - a
  },
  {
    name: 'iTunes',
    total: 23145.89,
    a: 20216.56, // 87% of total
    b: 2929.33, // total - a
  },
  {
    name: 'Deezer',
    total: 45678.34,
    a: 42912.12, // 94% of total
    b: 2766.22, // total - a
  },
  {
    name: 'Sound Cloud',
    total: 78123.67,
    a: 60140.88, // 77% of total
    b: 17982.79, // total - a
  },
  {
    name: 'Tidal',
    total: 90456.34,
    a: 81002.89, // 90% of total
    b: 9453.45, // total - a
  },
  {
    name: 'Meta',
    total: 12345.67,
    a: 9881.45, // 80% of total
    b: 2464.22, // total - a
  },
  {
    name: 'Tencent',
    total: 34567.89,
    a: 31654.23, // 92% of total
    b: 2913.66, // total - a
  },
  {
    name: 'TikTok',
    total: 25789.45,
    a: 23210.89, // 90% of total
    b: 2578.56, // total - a
  },
  {
    name: 'Vevo',
    total: 67234.56,
    a: 60511.78, // 90% of total
    b: 6722.78, // total - a
  },
  {
    name: 'Youtube',
    total: 45901.23,
    a: 41311.11, // 90% of total
    b: 4590.12, // total - a
  },
].sort((item1, item2) => {
  return item2.total - item1.total;
});
